import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import BranchListTable from "./BranchListTable";
import { useNavigate } from "react-router-dom";
import { FaRegBuilding } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { AiOutlineStock } from "react-icons/ai";
import { Weight } from "lucide-react";

const PharmacyMultibranches = () => {
  // KPI Data
  const kpis = [
    { title: "Total Branches", value: "25 (20 Active / 5 Inactive)",icon:<FaRegBuilding size={22} color="#48cdf5ff"/> },
    { title: "Total Stock Value", value: "₹ 1.2 Cr",icon:<IoCartOutline size={22} color="#66f16dff"/> },
    { title: "Low Stock Alerts", value: "12 Alerts (5 Branches)",icon:<AiOutlineStock size={22} color="#f75656ff"/> },
  ];

  // Chart Options
  const salesChartOptions = {
    chart: { type: "column" },
    title: { text: "Branch-wise Sales" },
    xAxis: { categories: ["Branch A", "Branch B", "Branch C"] },
    yAxis: { title: { text: "Sales Amount" } },
    series: [
      { name: "Today Sales", data: [12000, 8000, 15000], color: "#82ca9d" },
      { name: "Monthly Sales", data: [450000, 320000, 500000], color: "#8884d8" },
    ],
  };

const topMedicineChartOptions = {
  chart: { type: "pie" },
  title: { text: "Top-Selling Medicine Per Branch" },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: "pointer",
      dataLabels: {
        enabled: true,
        format: "{point.name}: {point.y}",
      },
    },
  },
  series: [
    {
      name: "Sales",
      colorByPoint: true,
      data: [
        { name: "Branch A - Paracetamol", y: 400 },
        { name: "Branch A - Amoxicillin", y: 300 },
        { name: "Branch B - Ibuprofen", y: 250 },
        { name: "Branch B - Vitamin C", y: 150 },
        { name: "Branch C - Paracetamol", y: 200 },
        { name: "Branch C - Ibuprofen", y: 100 },
      ],
    },
  ],
};


  const transferSummaryChartOptions = {
    chart: { type: "bar" },
    title: { text: "Inter-branch Transfer Summary" },
    xAxis: { categories: ["Pending", "Approved", "Completed"] },
    yAxis: { title: { text: "Transfers" } },
    series: [
      {
        name: "Transfers",
        data: [8, 15, 20],
        color: "#FF8042",
      },
    ],
  };

  // Ag-Grid Config
  const columnDefs = useMemo(
    () => [
      { headerName: "Branch ID", field: "id", flex: 1 },
      { headerName: "Name", field: "name", flex: 1 },
      { headerName: "Location", field: "location", flex: 1 },
      { headerName: "Contact Person", field: "contact", flex: 1 },
      { headerName: "Status", field: "status", flex: 1 },
    ],
    []
  );

  const navigate=useNavigate();


  return (
    <div className="p-6 space-y-6">
      {/* KPI Cards */}
     <div className="flex justify-between items-center mb-6">
  {/* Left: Title & Subtitle */}
  <div>
    <h1 className="" style={{fontSize:"1.3rem",  fontWeight:"600",}}>Multi-Branch Transfer</h1>
    <p className="text-gray-500 text-base mt-1">
      View KPIs, branch-wise sales, top medicines, and manage all branches
    </p>
  </div>

  {/* Right: Add Button */}
  <div>
    <button className="gradient-button" onClick={()=>navigate('/AddBranchPharmacy')}>+ Add New Branch</button>
  </div>
</div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {kpis.map((kpi, idx) => (
          <div key={idx} className="bg-white rounded-2xl shadow p-6 text-center">
           <div className="flex items-center justify-center mb-1">{kpi.icon}</div>
            <h3 className="text-gray-600 text-sm font-medium">{kpi.title}</h3>
            <p className="text-base font-bold text-blue-600">{kpi.value}</p>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-4 rounded-2xl shadow">
          <HighchartsReact highcharts={Highcharts} options={salesChartOptions} />
        </div>

        <div className="bg-white p-4 rounded-2xl shadow">
          <HighchartsReact highcharts={Highcharts} options={topMedicineChartOptions} />
        </div>

        <div className="bg-white p-4 rounded-2xl shadow">
          <HighchartsReact highcharts={Highcharts} options={transferSummaryChartOptions} />
        </div>
      </div>

      {/* Table Section */}
      <BranchListTable/>
    </div>
  );     
};

export default PharmacyMultibranches;
